// postMessage contract shared between the funnel iframe (this app, rendered at /embed/**) and the
// partner-site loader (src/embed/loader.ts, esbuild-bundled standalone to public/embed/v1/loader.js).
// Kept dependency-free so both bundlers can pull it in without side effects.

export const EMBED_CLOSE_MESSAGE = 'aurora-embed:close';
export const EMBED_ERROR_MESSAGE = 'aurora-embed:error';
// Partner loader → iframe: modal was hidden (successful close / reopen cycle)
export const EMBED_MODAL_CLOSE_MESSAGE = 'aurora-embed:modal-close';
// Partner loader → iframe: modal was revealed (CTA open / reopen)
export const EMBED_MODAL_OPEN_MESSAGE = 'aurora-embed:modal-open';
// Iframe → partner loader: open listener is mounted and can receive modal-open
export const EMBED_MODAL_READY_MESSAGE = 'aurora-embed:modal-ready';

// Partner-facing messages: (CustomEvent + dataLayer on the host page). GA4-safe names
export const EMBED_OPENED_MESSAGE = 'aurora_embed_opened';
export const EMBED_CLOSED_MESSAGE = 'aurora_embed_closed';
// A questions panel was submitted (`question` = QuestionsPanel string)
export const EMBED_QUESTION_MESSAGE = 'aurora_embed_question';
// Visitor connected with the embed host installer (in-SA)
export const EMBED_HOST_INSTALLER_CONNECTED_MESSAGE = 'aurora_embed_host_installer_connected';

// Open dwell before `embed_engaged_modal` — cancelled if modal-close arrives first
export const EMBED_ENGAGED_MODAL_MS = 8_000;

export type EmbedMessage = {
  message?: string;
  question?: string;
  type: string;
};
